import React, { FC } from 'react'
import image from 'styles/components/image.module.scss'
import styles from 'styles/components/typography.module.scss'
import { FlexRow } from 'components/Flex'

type Props = {
  dataCy?: string
  headline: string
  iconPath?: string
  id?: string
  onClick?: () => void
}

const MainHeadline: FC<Props> = React.memo((props) => {
  const { dataCy, headline, iconPath, id, onClick } = props
  return (
    <FlexRow justifyContent={'between'}>
      <h2 id={id} className={styles.headline_main} data-cy={dataCy}>
        {headline}
      </h2>
      {iconPath && (
        <img className={image.icon_clickable} src={iconPath} alt={`${headline}のアイコン`} onClick={onClick} />
      )}
    </FlexRow>
  )
})

export default MainHeadline
